/* eslint react-hooks/exhaustive-deps: "error" */
import React from 'react';
import { useApolloClient } from '@apollo/client';
import { useParams, useLocation } from 'react-router-dom';

import { css } from 'styled-components';

import { PrimaryButton, Loader } from '@crehana/ui';

import { useCrehanaLiveTranslations } from 'Jsx/CrehanaLive/hooks';

import GET_LIVE_B2B from '../../graphql/GetLiveDetailB2B.graphql';
import {
  GetLiveDetailB2B,
  GetLiveDetailB2BVariables,
} from '../../graphql/types/GetLiveDetailB2B';
import { LiveNode } from '../../graphql/types/LiveNode';

import Detail from '../Detail/Detail';

const RootDetail = () => {
  const { t } = useCrehanaLiveTranslations();
  const apolloClient = useApolloClient();
  const reactRouterParams = useParams<{ liveSlug: string; orgSlug: string }>();
  const { state } = useLocation<{ liveDetail: LiveNode }>();

  const [liveQuery, setLiveQuery] = React.useState<{
    loading: boolean;
    data: LiveNode | null;
    error: any;
  }>({
    loading: false,
    data: null,
    error: undefined,
  });

  React.useEffect(() => {
    if (state && state.liveDetail && state.liveDetail.url) {
      setLiveQuery(prev => ({
        ...prev,
        data: state.liveDetail,
      }));
    } else {
      setLiveQuery(prev => ({
        ...prev,
        loading: true,
      }));
      apolloClient
        .query<GetLiveDetailB2B, GetLiveDetailB2BVariables>({
          query: GET_LIVE_B2B,
          variables: {
            orgSlug: reactRouterParams.orgSlug,
            slug: reactRouterParams.liveSlug,
          },
        })
        .then(response => {
          if (response && response.data) {
            setLiveQuery({
              loading: false,
              data: response.data.livePrivateB2B,
              error: undefined,
            });
          } else {
            setLiveQuery({
              loading: false,
              data: null,
              error: 'Error!',
            });
          }
        })
        .catch(error => {
          setLiveQuery({
            loading: false,
            data: null,
            error,
          });
        });
    }
  }, [
    apolloClient,
    reactRouterParams.liveSlug,
    reactRouterParams.orgSlug,
    state,
  ]);

  if (liveQuery.error) {
    return (
      <div className="pt-64 flex flex-col items-center">
        <p className="font-body3 text-white">{t('ERROR_LOAD_B2B_DETAIL')}</p>
        <br />
        <PrimaryButton
          className="mt-32"
          label={t('RETRY_AGAIN_LABEL')}
          onClick={() => window.location.reload()}
          darkMode
        />
      </div>
    );
  }

  if (liveQuery.loading || !liveQuery.data) {
    return (
      <div className="pt-64" style={{ minHeight: 448 }}>
        <div className="mt-32 flex justify-center">
          <Loader white />
        </div>
      </div>
    );
  }

  return (
    <div
      css={css`
        height: calc(100vh - 52px);
        ${props => props.theme.breakpoints.up('md')} {
          height: calc(100vh - 72px);
        }
      `}
    >
      <Detail live={liveQuery.data} />
    </div>
  );
};

export default RootDetail;
